import React, { useState } from "react";
import { Button, Form, Input, message } from "antd";
import { useTranslation } from "react-i18next";
import { CountactUsService } from "../../queries/contactUs/contactUs.service";

const ContactForm = ({ formTextarea, formButton }) => {
  const { t } = useTranslation("common");
  const [hasSent, setHasSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSendMessage = (data) => {
    setLoading(true);
    CountactUsService.SendMessage(data)
      .then((d) => {
        setLoading(false);
        setHasSent(true);
        message.success(t("contact_us.success_message"));
      })
      .catch((e) => {
        setLoading(false);
      });
  };
  return (
    <div className="w-full">
      {hasSent ? (
        <div className="flex flex-col justify-center items-center mt-5 gap-5">
          <img src={"/static/images/confirm.svg"} className="w-[200px]" />
          <p className="text-base font-semibold text-center w-full md:w-[60%]">
            {t("landing.on_form_submit_sucess_message")}
          </p>
        </div>
      ) : (
        <Form onFinish={handleSendMessage} className="w-full">
          <div className="grid grid-cols-1 sm:grid-cols-2 mt-6 sm:gap-3 lg:gap-0 w-full lg:h-[65px]">
            <Form.Item
              name={"name"}
              rules={[
                {
                  required: true,
                  message: t("validation.required_message", {
                    name: t(
                      "common:landing.yoga_retreats_contact_us_input_first_name"
                    ),
                  }),
                },
              ]}
              style={{ marginBottom: "0" }}
            >
              <Input
                placeholder={t(
                  "common:landing.yoga_retreats_contact_us_input_first_name"
                )}
                className="placeholder:text-[#959499] border-solid border-2 !border-gray-200 rounded-[1.25rem] w-full lg:w-[90%] mb-4 lg:my-2 py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:!border-gray-400 cursor-pointer text-base bg-white"
              />
            </Form.Item>
            <Form.Item
              name={"email"}
              rules={[
                {
                  required: true,
                  message: t("validation.required_message", {
                    name: t(
                      "common:landing.yoga_retreats_contact_us_input_email"
                    ),
                  }),
                },
                {
                  type: "email",
                  message: t("validation.required_message", {
                    name: t(
                      "common:landing.yoga_retreats_contact_us_input_email"
                    ),
                  }),
                },
              ]}
              style={{ marginBottom: "0" }}
            >
              <Input
                placeholder={t(
                  "common:landing.yoga_retreats_contact_us_input_email"
                )}
                className="placeholder:text-[#959499] border-solid border-2 !border-gray-200 rounded-[1.25rem] w-full lg:w-[90%] mb-4 lg:my-2 py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:!border-gray-400 cursor-pointer text-base bg-white"
              />
            </Form.Item>
          </div>
          {formTextarea && (
            <span>
              <Form.Item
                name="message"
                rules={[
                  {
                    required: true,
                    message: t("validation.required_message", {
                      name: t("landing.contact_us_textarea_placeholder"),
                    }),
                  },
                ]}
                style={{ marginBottom: "0" }}
              >
                <Input.TextArea
                  placeholder={
                    t("landing.contact_us_textarea_placeholder") + " *"
                  }
                  className={`placeholder:text-[#959499] border-solid border-2 !border-gray-200 rounded-[1.25rem] w-full lg:w-[95%] mb-4 lg:mt-2 py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:!border-gray-400 cursor-pointer text-base bg-white !resize-none !min-h-[150px]`}
                ></Input.TextArea>
              </Form.Item>
            </span>
          )}
          <Button
            loading={loading}
            className={
              " !text-[18px]  btn-orange font-medium flex flex-row self-center gap-x-2 justify-center text-base py-3 rounded-full lg:!w-fit px-16"
            }
            htmlType={"submit"}
            block
          >
            {formButton}
          </Button>
        </Form>
      )}
    </div>
  );
};

export default ContactForm;
